<div class="content ap-display-flex ap-align-items-center ap-text-align-center">
    <div
        [innerHTML]="text()"
        class="ap-padding-2 ap-padding-top-1 ap-padding-bottom-0 ap-width-100"
        data-testid="participant-divider-text"
    ></div>
</div>
